import {
    ChangeEvent,
    SyntheticEvent,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";

import { useCookies } from "react-cookie";

import {
    CommandType,
    CommandQueueType,
    CustomerListType,
    DepartmentSimpleType,
    EventResponse,
    MqttCommandDeliveryStatusType,
    MqttCommandStatusType,
    SecretarySimpleType,
    SelectedParametersType,
    SendCommandType,
    UserType,
    VehicleListType,
} from "../../../../types/types";

import {
    customerDefault,
    departmentDefault,
    secretaryDefault
} from "../../../../consts/consts";

import { ContentProps, Toast } from "primereact/toast";

import {
    getApiErrorMessage,
    getMqttCommandStatusCardStyle,
    getMqttCommandStatusInfo,
    isMqttCommandProtocol,
    mqttCommandStatusPalette,
    setToastRefToOpen,
} from "../../../../functions/functions";

import {
    Alert,
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    FormControl,
    FormGroup,
    IconButton,
    InputLabel,
    LinearProgress,
    Paper,
    Skeleton,
    Stack,
    Step,
    StepContent,
    StepLabel,
    Stepper,
    styled,
    SwipeableDrawer,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";

import {
    AbcOutlined,
    ArrowForwardOutlined,
    ArticleOutlined,
    AutoDeleteOutlined,
    CachedOutlined,
    CloseOutlined,
    LocalShippingRounded,
    PinOutlined,
    Refresh,
    SendToMobileOutlined,
    SevenMpOutlined,
    UndoOutlined,
    ListAltOutlined,
    DeleteOutlineOutlined,
} from "@mui/icons-material";

import { useRecoilValue } from "recoil";
import { userAtom } from "../../../../atoms/atoms";

import Switch, { SwitchProps } from '@mui/material/Switch';

import sendCommandById from "../../../../resources/Api/device/sendCommandById";
import sendCommandByIdMqtt from "../../../../resources/Api/device/sendCommandByIdMqtt";
import findMqttCommandStatusByIdResponse from "../../../../resources/Api/device/findMqttCommandStatusByIdResponse";
import findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse from "../../../../resources/Api/vehicle/findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse";
import findAllSecretariesByCustomerIdListResponse from "../../../../resources/Api/secretary/findAllSecretariesByCustomerIdListResponse";
import findAllDepartmentsByCustomerIdAndSecretaryIdListResponse from "../../../../resources/Api/department/findAllDepartmentsByCustomerIdAndSecretaryIdListResponse";
import customerFindAllListResponse from "../../../../resources/Api/customer/customerFindAllListResponse";
import commandFindLastFiveResultResponse from "../../../../resources/Api/event/commandFindLastFiveResultResponse";
import { findAllCommandsByDeviceIdListResponse, findAllCommandsByPlateListResponse } from "../../../../resources/Api/device/findAllCommandsByDeviceIdListResponse";
import commandQueueFindAllByDeviceId from "../../../../resources/Api/command/commandQueueFindAllByDeviceId";
import commandQueueDeleteById from "../../../../resources/Api/command/commandQueueDeleteById";

const drawerBleeding = 56;

const Puller = styled('div')(({ theme }) => ({
    width: 30,
    height: 6,
    backgroundColor: "rgba(255,255,255,0.45)",
    borderRadius: 3,
    position: 'absolute',
    top: 8,
    left: 'calc(50% - 15px)',
    ...theme.applyStyles('dark', {
        backgroundColor: "rgba(255,255,255,0.45)",
    }),
}));

type MqttCommandResultAttributes = {
    description?: string;
    result?: string;
    commandId?: string;
    status?: MqttCommandStatusType;
};

type CommandLogInfo = {
    displayName: string;
    logData: string;
    displayDescription: string;
    displayDescriptionLabel: string;
    commandId: string;
    status: MqttCommandStatusType | null;
};

const DeviceCommandComponent = () => {
    // atoms
    const getCurrentUser = useRecoilValue<UserType>(userAtom);

    // funcionalities states
    const [isOnline, setIsOnline] = useState<boolean>(true);
    const [isOpenDetails, setIsOpenDetails] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [isSendingCommand, setIsSendingCommand] = useState<boolean>(false);
    const [validationText, setTextValidation] = useState<string>("");
    const [isFieldsValid, setFieldsIsValid] = useState<boolean>(true);
    const [statusMessage, setStatusMessage] = useState<"warn" | "success" | "info" | "error" | undefined>("warn");
    const [isToastVisible, setIsToastVisible] = useState(false);

    // states
    const [customersList, setCustomersList] = useState<Array<CustomerListType>>([]);
    const [secretariesList, setSecretariesList] = useState<Array<SecretarySimpleType>>([]);
    const [departmentsList, setDepartmentsList] = useState<Array<DepartmentSimpleType>>([]);
    const [activeStep, setActiveStep] = useState<number>(0);

    const [customer, setCustomer] = useState<CustomerListType>(customerDefault);
    const [secretary, setSecretary] = useState<SecretarySimpleType>(secretaryDefault);
    const [department, setDepartment] = useState<DepartmentSimpleType>(departmentDefault);

    const [deviceCommandName, setDeviceCommandName] = useState<string>("");
    const [deviceCommandsList, setDeviceCommandList] = useState<Array<CommandType>>([]);
    const [vehicleList, setVehicleList] = useState<Array<VehicleListType>>([]);
    const [selectedVehicle, setSelectedVehicle] = useState<VehicleListType | null>({ id: -1 } as any);

    const [isHandleCommandChecked, setIsHandleCommandChecked] = useState<boolean>(false);
    const [handleCommandLine, setHandleCommandLine] = useState<string>("");
    const [commandResult, setCommandResult] = useState<Array<EventResponse>>([]);
    const [isCommandResultLoading, setIsCommandResultLoading] = useState<boolean>(false);
    const [mqttCommandDelivery, setMqttCommandDelivery] = useState<MqttCommandDeliveryStatusType | null>(null);

    const [isSetOdometerChecked, setIsSetOdometerChecked] = useState<boolean>(false);
    const [isSetSpeedLimitChecked, setIsSetSpeedChecked] = useState<boolean>(false);
    const [isSetIbuttonChecked, setIsSetIbuttonChecked] = useState<boolean>(false);
    const [isSetApnChecked, setIsSetApnChecked] = useState<boolean>(false);
    const [isSetConfiDnsChecked, SetIsSetConfiDnsChecked] = useState<boolean>(false);

    const [isHandlePlateChecked, setIsHandlePlateChecked] = useState<boolean>(false);
    const [plateCurrent, setPlateCurrent] = useState<string>("");

    const [odometerValue, setOdometerValue] = useState<string>("");

    const [speedLimit, setSpeedLimit] = useState<string>("");
    const [digout, setDigOut] = useState<string>("");
    const [alarmTime, setAlarmTime] = useState<string>("");

    const [identifiers, setIdentifiers] = useState<string>("");
    const [identifierPort, setIdentifierPort] = useState<string>("");

    const [apn, setApn] = useState<string>("");
    const [login, setLogin] = useState<string>("");
    const [password, setPassword] = useState<string>("");

    const [dns, setDns] = useState<string>("");
    const [port, setPort] = useState<string>("");
    const [open, setOpen] = useState(false);

    const [isQueueOpen, setIsQueueOpen] = useState<boolean>(false);
    const [commandQueue, setCommandQueue] = useState<Array<CommandQueueType>>([]);
    const [loadingQueue, setLoadingQueue] = useState<boolean>(false);

    // Confirmation state and refs
    const toastModalRef = useRef<Toast>(null);
    const [cookies] = useCookies(["selectedParameters", "token"]);

    // refs
    const toastRef = useRef<Toast>(null);
    const mqttPollingTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const mqttCommandIdRef = useRef<string | null>(null);
    const commandResultTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const commandResultRequestPendingRef = useRef<boolean>(false);
    const commandResultRequestVersionRef = useRef<number>(0);

    const stopMqttCommandPolling = useCallback(() => {
        mqttCommandIdRef.current = null;
        if (mqttPollingTimeoutRef.current) {
            clearTimeout(mqttPollingTimeoutRef.current);
            mqttPollingTimeoutRef.current = null;
        }
    }, []);

    const getCommandQueue = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        if (!selectedVehicle?.deviceId || selectedVehicle.deviceId < 0) {
            setCommandQueue([]);
            return;
        }

        setLoadingQueue(true);
        try {
            const { data } = await commandQueueFindAllByDeviceId(token, selectedVehicle?.deviceId as number);
            setCommandQueue(data);
        } catch {
            setCommandQueue([]);
        } finally {
            setLoadingQueue(false);
        }
    }, [cookies.token, selectedVehicle?.deviceId]);

    const toggleQueueDrawer = (newOpen: boolean) => () => {
        setIsQueueOpen(newOpen);
        if (newOpen) {
            getCommandQueue();
        }
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        if (isHandlePlateChecked && plateCurrent != "") {
            setActiveStep(0);
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
    };

    const currentParameters: SelectedParametersType = useMemo(() => cookies.selectedParameters, [cookies.selectedParameters]);
    const selectedCommandProtocol = useMemo(
        () => deviceCommandsList.find((item) => item.description === deviceCommandName)?.protocolName
            ?? deviceCommandsList.find((item) => item.protocolName)?.protocolName
            ?? null,
        [deviceCommandName, deviceCommandsList]
    );
    const mqttCommandStatusInfo = useMemo(
        () => getMqttCommandStatusInfo(mqttCommandDelivery?.status),
        [mqttCommandDelivery?.status]
    );

    const handleClose = useCallback(() => {
        setLoading(false);
        setStatusMessage("warn");
        setIsToastVisible(false);
        setFieldsIsValid(true);
        setTextValidation("");
        setIsOpenDetails(false);
        setActiveStep(0);
        setCustomer(customerDefault);
        setSecretary(secretaryDefault);
        setDepartment(departmentDefault);
        setIsHandleCommandChecked(false);
        setHandleCommandLine("");
        setDeviceCommandList([]);
        setSelectedVehicle({ id: -1 } as any);
        setSpeedLimit("");
        setDigOut("");
        setAlarmTime("");
        setIdentifierPort("");
        setIdentifiers("");
        setApn("");
        setLogin("");
        setPassword("");
        setDns("");
        setPort("");
        setOdometerValue("");
    }, []);

    useEffect(() => {
        if (validationText && !isFieldsValid && !isToastVisible) {
            setToastRefToOpen(
                toastRef,
                validationText,
                "Atenção!",
                statusMessage,
                undefined,
                3000,
                false
            );
        }
    }, [
        isOpenDetails,
        validationText,
        isFieldsValid,
        statusMessage,
        isToastVisible,
        toastRef
    ]);

    const getCustomersList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        try {
            const response = await customerFindAllListResponse(token, currentParameters.customer.id);
            setCustomersList(response.data);
        } catch (error) {
            console.log(error);
            setCustomersList([]);
        }
    }, [cookies.token, currentParameters]);

    useEffect(() => {
        if (getCurrentUser.configs.isManager) {
            getCustomersList();
        }
    }, [getCustomersList, getCurrentUser.configs.isManager]);

    const getSecretariesList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer?.id : customer.id;

        try {
            const response = await findAllSecretariesByCustomerIdListResponse(
                token,
                customerId
            );
            setSecretariesList(response.data);
        } catch (error) {
            console.log(error);
            setSecretariesList([]);
        }
    }, [cookies.token, customer?.id, currentParameters?.customer?.id, getCurrentUser.configs.isManager]);

    useEffect(() => {
        if (customer?.name || currentParameters?.customer?.id) {
            getSecretariesList();
        }
    }, [getSecretariesList, customer?.name, currentParameters?.customer.id]);

    const getDepartmentsList = useCallback(async () => {
        const token = cookies.token || sessionStorage.getItem("token");
        const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;
        const secretaryId = (!getCurrentUser.configs.isManager && !currentParameters?.isViewingAll) ? currentParameters?.secretary.id : secretary.id;

        try {
            const response =
                await findAllDepartmentsByCustomerIdAndSecretaryIdListResponse(
                    token,
                    customerId,
                    secretaryId
                );
            setDepartmentsList(response.data);
        } catch (error) {
            console.log(error);
            setDepartmentsList([]);
        }
    }, [cookies.token, customer?.id, secretary?.id, currentParameters?.secretary.id, currentParameters?.customer.id, getCurrentUser.configs.isManager, currentParameters?.isViewingAll]);

    useEffect(() => {
        if (secretary?.name || currentParameters?.secretary?.name) {
            getDepartmentsList();
        }
    }, [getDepartmentsList, secretary?.name, currentParameters?.department?.name, currentParameters?.secretary?.name, currentParameters?.isViewingAll]);

    const getAllVehicles = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");

        const customerId = !getCurrentUser.configs.isManager ? currentParameters?.customer.id : customer.id;
        // const secretaryId = !getCurrentUser.configs.isManager ? currentParameters?.secretary.id : secretary.id;
        const departmentId = (!getCurrentUser.configs.isManager && !currentParameters?.isViewingAll) ? currentParameters?.department.id : department.id;

        try {
            const { data } =
                await findAllVehiclesByCustomerIdAndSecretaryIdAndDepartmentIdListResponse(
                    token,
                    customerId,
                    departmentId
                );
            setVehicleList(data);
        } catch (error: any) {
            console.log(error);
            setVehicleList([]);
        }
    }, [
        currentParameters?.isViewingAll,
        getCurrentUser?.configs.isManager,
        currentParameters?.customer.id,
        currentParameters?.department.id,
        customer.id,
        department.id,
        cookies.token
    ]);

    useEffect(() => {
        if ((department.name || currentParameters?.department.name) && !isHandlePlateChecked) {
            getAllVehicles();
        }
    }, [getAllVehicles, department.name, currentParameters?.department.name, isHandlePlateChecked]);

    const getAllCommandsByDevice = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const managerId = !getCurrentUser.configs.isManager ? getCurrentUser.customer.managerId : currentParameters.customer.id;

        try {
            const { data } =
                await findAllCommandsByDeviceIdListResponse(
                    token,
                    managerId!!,
                    selectedVehicle?.deviceId as any,
                    "PRINCIPAL"
                );
            setDeviceCommandList(data);
        } catch (error: any) {
            setDeviceCommandList([]);
            setLoading(false);
            setFieldsIsValid(false);
            setStatusMessage("warn");
            setTextValidation(getApiErrorMessage(error, "Erro ao buscar os comandos do dispositivo."));
        }
    }, [cookies.token, selectedVehicle?.deviceId, currentParameters.customer.id, getCurrentUser.customer.managerId, getCurrentUser.configs.isManager]);

    useEffect(() => {
        if (selectedVehicle?.deviceId && !isHandlePlateChecked) {
            getAllCommandsByDevice();
        } else if (!isHandlePlateChecked && selectedVehicle?.satelliteImei) {
            setLoading(false);
            setFieldsIsValid(false);
            setStatusMessage("warn");
            setTextValidation("Dispositivo não suporta envio de comandos.");
        }
    }, [getAllCommandsByDevice, selectedVehicle?.deviceId, isHandlePlateChecked, selectedVehicle?.satelliteImei]);

    // Função de buscar comandos por placa
    const getAllCommandsByPlate = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const managerId = !getCurrentUser.configs.isManager ? getCurrentUser?.customer.managerId : currentParameters.customer.id;

        try {
            const { data } =
                await findAllCommandsByPlateListResponse(
                    token,
                    managerId!!,
                    plateCurrent,
                    "PRINCIPAL"
                );
            setDeviceCommandList(data);
            if (data.length > 0) {
                setActiveStep(2);
            }
        } catch (error: any) {
            setDeviceCommandList([]);
            setLoading(false);
            setFieldsIsValid(false);
            setStatusMessage("warn");
            setTextValidation(getApiErrorMessage(error, "Erro ao buscar os comandos do veículo."));
        }
    }, [cookies.token, plateCurrent, currentParameters.customer.id, getCurrentUser.customer.managerId, getCurrentUser.configs.isManager]);

    useEffect(() => {
        if (isHandlePlateChecked && plateCurrent.length >= 4) {
            getAllCommandsByPlate();
        }
    }, [getAllCommandsByPlate, plateCurrent, isHandlePlateChecked]);

    const cancelCommandResultRequest = useCallback((updateState = true) => {
        commandResultRequestVersionRef.current += 1;
        commandResultRequestPendingRef.current = false;

        if (commandResultTimeoutRef.current) {
            clearTimeout(commandResultTimeoutRef.current);
            commandResultTimeoutRef.current = null;
        }

        if (updateState) {
            setIsCommandResultLoading(false);
            setLoading(false);
        }
    }, []);

    const getLastFiveCommandResult = useCallback((token: string, shouldOpen = true, delay = 3000) => {
        if (shouldOpen) setOpen(true);
        if (commandResultRequestPendingRef.current) return;

        const requestVersion = commandResultRequestVersionRef.current + 1;
        commandResultRequestVersionRef.current = requestVersion;
        commandResultRequestPendingRef.current = true;
        setIsCommandResultLoading(true);
        setLoading(true);

        commandResultTimeoutRef.current = setTimeout(async () => {
            commandResultTimeoutRef.current = null;
            try {
                const { data } = await commandFindLastFiveResultResponse(token, selectedVehicle?.deviceId!!, plateCurrent);
                if (commandResultRequestVersionRef.current !== requestVersion) return;
                setCommandResult(data);
            } catch (error: any) {
                if (commandResultRequestVersionRef.current !== requestVersion) return;
                console.log(error);
                setCommandResult([]);
            } finally {
                if (commandResultRequestVersionRef.current === requestVersion) {
                    commandResultRequestPendingRef.current = false;
                    setIsCommandResultLoading(false);
                    setLoading(false);
                }
            }
        }, delay);
    }, [selectedVehicle?.deviceId, plateCurrent]);

    const trackMqttCommand = useCallback((commandId: string, token: string, expiresAt?: string | null) => {
        stopMqttCommandPolling();
        mqttCommandIdRef.current = commandId;

        let consecutiveErrors = 0;
        const expiresAtMillis = expiresAt ? Date.parse(expiresAt) : Number.NaN;

        const poll = async () => {
            if (mqttCommandIdRef.current !== commandId) return;

            try {
                const { data } = await findMqttCommandStatusByIdResponse(token, commandId);
                if (mqttCommandIdRef.current !== commandId) return;

                consecutiveErrors = 0;
                setMqttCommandDelivery(data);

                const statusInfo = getMqttCommandStatusInfo(data.status);
                if (statusInfo.terminal) {
                    stopMqttCommandPolling();
                    const detail = data.response?.trim() || data.error?.trim();
                    setTextValidation(detail ? `${statusInfo.label}: ${detail}` : statusInfo.label);
                    setStatusMessage(statusInfo.severity);
                    setFieldsIsValid(false);
                    getLastFiveCommandResult(token, false, 1000);
                    getCommandQueue();
                    return;
                }
            } catch (error: any) {
                if (mqttCommandIdRef.current !== commandId) return;

                consecutiveErrors += 1;
                const status = error?.response?.status;
                const mustStop = status === 401 || status === 403 || status === 404 || consecutiveErrors >= 3;

                if (mustStop) {
                    stopMqttCommandPolling();
                    setTextValidation(
                        getApiErrorMessage(error, "Não foi possível acompanhar o retorno do comando.")
                    );
                    setStatusMessage(status === 401 || status === 403 ? "error" : "warn");
                    setFieldsIsValid(false);
                    return;
                }
            }

            if (!Number.isNaN(expiresAtMillis) && Date.now() > expiresAtMillis + 15000) {
                stopMqttCommandPolling();
                setTextValidation("O prazo do comando terminou sem confirmação do status final.");
                setStatusMessage("warn");
                setFieldsIsValid(false);
                return;
            }

            mqttPollingTimeoutRef.current = setTimeout(poll, 2000);
        };

        void poll();
    }, [getCommandQueue, getLastFiveCommandResult, stopMqttCommandPolling]);

    const refreshMqttCommandDelivery = useCallback(async () => {
        const commandId = mqttCommandDelivery?.commandId;
        if (!commandId) return;

        const token: string = cookies.token || sessionStorage.getItem("token");
        try {
            const { data } = await findMqttCommandStatusByIdResponse(token, commandId);
            setMqttCommandDelivery(data);

            const statusInfo = getMqttCommandStatusInfo(data.status);
            if (statusInfo.terminal) {
                stopMqttCommandPolling();
                const detail = data.response?.trim() || data.error?.trim();
                setTextValidation(detail ? `${statusInfo.label}: ${detail}` : statusInfo.label);
                setStatusMessage(statusInfo.severity);
                setFieldsIsValid(false);
                getLastFiveCommandResult(token, false, 1000);
                getCommandQueue();
            }
        } catch (error: any) {
            const status = error?.response?.status;
            setTextValidation(
                getApiErrorMessage(error, "Não foi possível atualizar o estado do comando.")
            );
            setStatusMessage(status === 401 || status === 403 ? "error" : "warn");
            setFieldsIsValid(false);
        }
    }, [
        cookies.token,
        getCommandQueue,
        getLastFiveCommandResult,
        mqttCommandDelivery?.commandId,
        stopMqttCommandPolling,
    ]);

    useEffect(() => () => {
        stopMqttCommandPolling();
        cancelCommandResultRequest(false);
    }, [cancelCommandResultRequest, stopMqttCommandPolling]);

    useEffect(() => {
        stopMqttCommandPolling();
        cancelCommandResultRequest();
        setMqttCommandDelivery(null);
        setCommandQueue([]);
        setCommandResult([]);
        setDeviceCommandList([]);
        setDeviceCommandName("");
    }, [cancelCommandResultRequest, plateCurrent, selectedVehicle?.deviceId, stopMqttCommandPolling]);

    const toggleDrawer = useCallback((newOpen: boolean) => () => {
        setOpen(newOpen);
        if (newOpen) {
            const token: string = cookies.token || sessionStorage.getItem("token");
            getLastFiveCommandResult(token);
        } else {
            cancelCommandResultRequest();
        }
    }, [cancelCommandResultRequest, cookies.token, getLastFiveCommandResult]);

    const getLogInfo = useCallback((log: EventResponse): CommandLogInfo | null => {
        if (!log) return null;

        if (typeof log.name === "string" && log.name.trim().startsWith("{")) {
            try {
                const mqttLog = JSON.parse(log.name) as MqttCommandResultAttributes;
                if (mqttLog.commandId && mqttLog.status) {
                    const statusInfo = getMqttCommandStatusInfo(mqttLog.status);
                    return {
                        displayName: statusInfo.label,
                        logData: mqttLog.description || "Comando não informado",
                        displayDescription: mqttLog.result !== mqttLog.status ? mqttLog.result || "" : "",
                        displayDescriptionLabel: mqttLog.status === "RESPONDED" ? "Resposta" : "Detalhe",
                        commandId: mqttLog.commandId,
                        status: mqttLog.status,
                    };
                }
            } catch {
                // Mantém abaixo o tratamento dos eventos de comandos no formato legado.
            }
        }

        const isGeneric = !log.name || log.name === "Resultado do Comando" || (log.name && log.name.startsWith("{data:"));

        let logData = "";
        if (!logData && log.name && log.name.startsWith("{data:")) {
            logData = log.name.replace("{data: ", "").replace("}", "").trim();
        }

        let displayName = log.name;
        if (isGeneric) {
            const matched = deviceCommandsList.find(c => {
                if (c.attributes === logData) return true;
                try {
                    const parsed = JSON.parse(c.attributes);
                    return parsed.data === logData;
                } catch {
                    return false;
                }
            });
            displayName = matched?.description || "Resultado do Comando";
        }

        return {
            displayName: !isGeneric || (log.name && !log.name.startsWith("{data:")) ? log.name : displayName,
            logData,
            displayDescription: "",
            displayDescriptionLabel: "",
            commandId: "",
            status: null,
        };
    }, [deviceCommandsList]);

    const onCancelQueueCommand = useCallback(async (id: number) => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        setLoadingQueue(true);
        try {
            await commandQueueDeleteById(token, id);
            setTextValidation("Comando cancelado com sucesso.");
            setStatusMessage("success");
            setFieldsIsValid(false);
            getCommandQueue(); // Refresh the queue
        } catch (error: any) {
            setTextValidation(getApiErrorMessage(error, "Erro ao cancelar comando."));
            setStatusMessage("error");
            setFieldsIsValid(false);
        } finally {
            setLoadingQueue(false);
        }
    }, [cookies.token, getCommandQueue]);

    const verifyBeforeCancelQueueCommand = useCallback(
        (id: number) => {
            const ref = toastModalRef;
            if (!isToastVisible) {
                setToastRefToOpen(
                    ref,
                    "Deseja realmente cancelar o comando selecionado?",
                    "Atenção!",
                    "warn",
                    {
                        content: (props: ContentProps) => (
                            <Box
                                className="flex flex-column align-items-left"
                                style={{ flex: "1" }}
                            >
                                <Typography sx={{ fontFamily: "Prometo" }}>{props?.message.summary}</Typography>
                                <Box className="font-medium text-lg my-3 text-900" sx={{ fontFamily: "Prometo" }}>
                                    {props?.message.detail}
                                </Box>


                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                        onCancelQueueCommand(id);
                                    }}
                                >
                                    Sim
                                </Button>
                                <Button
                                    className="p-button-sm flex"
                                    style={{ cursor: "pointer", color: "inherit" }}
                                    onClick={() => {
                                        ref.current?.clear();
                                        setIsToastVisible(false);
                                    }}
                                >
                                    Não
                                </Button>
                            </Box>
                        ),
                    },
                    undefined,
                    true
                );
                setIsToastVisible(true);
            }
        },
        [onCancelQueueCommand, isToastVisible, statusMessage]
    );

    const onSendCommand = useCallback(async () => {
        setLoading(true);
        setIsSendingCommand(true);
        const token: string = cookies.token || sessionStorage.getItem("token");

        const customerId = !getCurrentUser.configs.isManager
            ? currentParameters?.customer.id
            : isHandlePlateChecked ? -1 : customer.id;

        const isMqttCommand = isMqttCommandProtocol(selectedCommandProtocol);
        const deviceId = isHandlePlateChecked ? -1 : selectedVehicle?.deviceId ?? -1;

        const commandLine = (isSetConfiDnsChecked || isHandleCommandChecked || isSetIbuttonChecked || isSetOdometerChecked || isSetApnChecked || isSetSpeedLimitChecked)
            ? handleCommandLine
            : deviceCommandName;

        const isCommandLine = (isSetConfiDnsChecked || isHandleCommandChecked || isSetIbuttonChecked || isSetOdometerChecked || isSetApnChecked || isSetSpeedLimitChecked);

        const dataCommand: SendCommandType = {
            token: token,
            deviceType: "PRINCIPAL",
            commandDesc: commandLine,
            deviceId: deviceId,
            deviceImei: isHandlePlateChecked
                ? plateCurrent
                : isMqttCommand
                    ? selectedVehicle?.deviceImei ?? ""
                    : `${selectedVehicle?.name} - ${selectedVehicle?.vehiclePlate}(${selectedVehicle?.deviceImei})`,
            customerId: customerId,
            name: getCurrentUser.name,
            email: getCurrentUser.email,
            isCommandLine: isCommandLine,
            cameraConfig: null
        };

        try {
            const response = isMqttCommand
                ? await sendCommandByIdMqtt(dataCommand)
                : await sendCommandById(dataCommand);

            if (isMqttCommand) {
                const commandId = response.data.commandId;
                if (!commandId) {
                    setTextValidation("O comando foi recebido, mas não retornou um identificador para acompanhamento.");
                    setStatusMessage("warn");
                    setFieldsIsValid(false);
                    return;
                }

                setMqttCommandDelivery({
                    commandId,
                    deviceId: response.data.deviceId,
                    imei: response.data.imei ?? "",
                    status: "PENDING_PUBLISH",
                    description: dataCommand.commandDesc,
                    expiresAt: "",
                    publishedAt: null,
                    sentToDeviceAt: null,
                    respondedAt: null,
                    response: null,
                    error: null,
                });
                setOpen(true);
                trackMqttCommand(commandId, token, response.data.expiresAt);
                getCommandQueue();
                setTextValidation("Comando adicionado à fila para envio.");
            } else {
                setTextValidation("Comando enviado com sucesso.");
                getLastFiveCommandResult(token);
            }

            setStatusMessage(isMqttCommand ? "info" : "success");
            setFieldsIsValid(false);
            setHandleCommandLine("");
            setSpeedLimit("");
            setDigOut("");
            setAlarmTime("");
            setIdentifierPort("");
            setIdentifiers("");
            setApn("");
            setLogin("");
            setPassword("");
            setDns("");
            setPort("");
            setOdometerValue("");
            setDeviceCommandName("");
            setIsHandleCommandChecked(false);
            setIsSetOdometerChecked(false);
            setIsSetApnChecked(false);
            setIsSetIbuttonChecked(false);
            SetIsSetConfiDnsChecked(false);
        } catch (error: any) {
            const status = error?.response?.status;
            setOpen(false);
            setFieldsIsValid(false);
            setStatusMessage("warn");

            if (status === 504 || status === 408 || status === 502 || status === 503) {
                setTextValidation("A solicitação demorou mais do que o esperado para responder, aguarde alguns instantes e tente novamente.");
            } else {
                setTextValidation(getApiErrorMessage(error, "Erro ao enviar comando. Tente novamente."));
            }
        } finally {
            setLoading(false);
            setIsSendingCommand(false);
        }
    }, [
        getCommandQueue,
        getLastFiveCommandResult,
        trackMqttCommand,
        plateCurrent,
        handleCommandLine,
        selectedVehicle?.deviceId,
        getCurrentUser.configs.isManager,
        cookies.token,
        deviceCommandName,
        getCurrentUser.email,
        currentParameters?.customer.id,
        customer?.id,
        getCurrentUser.name,
        selectedVehicle?.deviceImei,
        selectedVehicle?.name,
        selectedVehicle?.vehiclePlate,
        selectedCommandProtocol,
        isHandlePlateChecked,
        isSetConfiDnsChecked,
        isHandleCommandChecked,
        isSetIbuttonChecked,
        isSetOdometerChecked,
        isSetApnChecked,
        isSetSpeedLimitChecked
    ]);

    useEffect(() => {
        if (activeStep === 2 && (selectedVehicle?.deviceId || plateCurrent)) {
            const token: string = cookies.token || sessionStorage.getItem("token");
            getLastFiveCommandResult(token, false, 1000);
        }
    }, [activeStep, selectedVehicle?.deviceId, plateCurrent, cookies.token, getLastFiveCommandResult]);

    const IOSSwitch = useMemo(() => styled((props: SwitchProps) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#65C466',
                    opacity: 1,
                    border: 0,
                    ...theme.applyStyles('dark', {
                        backgroundColor: '#2ECA45',
                    }),
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.grey[100],
                ...theme.applyStyles('dark', {
                    color: theme.palette.grey[600],
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7,
                ...theme.applyStyles('dark', {
                    opacity: 0.3,
                }),
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: '#E9E9EA',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
            ...theme.applyStyles('dark', {
                backgroundColor: '#39393D',
            }),
        },
    })), []);

    // Função para envio de comandos personalizados
    const handleCommandOptions = useCallback(() => {
        let comandLine = "";
        if (isSetOdometerChecked && odometerValue !== "") {
            comandLine = `odoset:${odometerValue}`;
        } else if (isSetSpeedLimitChecked && speedLimit !== "" && digout !== "") {
            const time = alarmTime !== "" ? alarmTime : "0";
            comandLine = `setparam 11100:2;11104:${speedLimit};11103:1;11101:${time};11102:${time}${digout === "2" ? ";11106:2" : ""}`;
        } else if (isSetIbuttonChecked && identifiers !== "" && identifierPort !== "") {
            // Quebra a string de IDs e remove entradas vazias
            const list = identifiers
                .split(';')
                .map(id => id.trim())
                .filter(id => id);

            const params = list
                .map((identifier, idx) => `${Number(identifierPort) + idx}:${identifier}`)
                .join(';');

            // Moanta a linha final
            comandLine = `setparam ${params}`;
        } else if (isSetApnChecked && apn !== "" && login !== "" && password !== "") {
            comandLine = `setparam 2000:1;2001:${apn};2002:${login};2003:${password}`;
        } else if (isSetConfiDnsChecked && dns !== "" && port !== "") {
            comandLine = `setparam 2004:${dns};2005:${port};2006:0`;
        }
        setHandleCommandLine(comandLine);
    }, [identifierPort, dns, port, apn, login, password, isSetOdometerChecked, isSetApnChecked, isSetConfiDnsChecked, isSetIbuttonChecked, isSetSpeedLimitChecked, odometerValue, speedLimit, alarmTime, digout, identifiers]);

    useEffect(() => {
        handleCommandOptions();
    }, [handleCommandOptions]);

    const steps = useMemo(() => [
        {
            label: "Identificação",
            item: (
                <>
                    <Paper className="trv-container tw-rounded-xl tw-border-0 tw-bg-white tw-shadow-none" elevation={0} sx={{ ...style, marginBottom: 2 }}>
                        <Box
                            className="command-plate-toggle tw-w-full"
                            sx={{
                                minHeight: 56,
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px !important",
                                border: "none",
                                borderRadius: 2,
                                backgroundColor: "#f3f4f6",
                            }}
                        >
                            <FormGroup>
                                <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                    <IOSSwitch
                                        checked={isHandlePlateChecked}
                                        onChange={(event) => {
                                            const checked = event.target.checked;

                                            if (!checked) {
                                                setPlateCurrent("");
                                            }

                                            setIsHandlePlateChecked(checked);
                                            setLoading(false);
                                            setStatusMessage("warn");
                                            setIsToastVisible(false);
                                            setFieldsIsValid(true);
                                            setTextValidation("");
                                            setIsOpenDetails(false);
                                            setActiveStep(0);
                                            setCustomer(customerDefault);
                                            setSecretary(secretaryDefault);
                                            setDepartment(departmentDefault);
                                            setIsHandleCommandChecked(false);
                                            setHandleCommandLine("");
                                            setDeviceCommandList([]);
                                            setSelectedVehicle({ id: -1 } as any);

                                        }}
                                        inputProps={{ 'aria-label': 'ant design' }}
                                    />
                                    <Typography sx={{ color: "#334155", fontFamily: "Prometo", fontWeight: 600 }}>
                                        Envio por placa
                                    </Typography>
                                </Stack>
                            </FormGroup>
                        </Box>

                        <Box className="col-md-12">
                            <FormControl
                                className="form-group"
                                style={{ display: "flex", width: "100%" }}
                                disabled={isHandlePlateChecked}
                            >
                                <InputLabel id="demo-multiple-cpf-label" shrink disabled={isHandlePlateChecked} required>
                                    Veículo
                                </InputLabel>
                                <TextField
                                    name="plate"
                                    type="text"
                                    // ref={(ref) => (plateRef.current = ref)}
                                    autoComplete="off"
                                    required
                                    inputProps={{ maxLength: 15 }}
                                    InputProps={{ label: "Veículo", notched: true }}
                                    placeholder="Digite a placa ou nome do veículo"
                                    className="form-control vehicle-plate"
                                    value={plateCurrent}
                                    onChange={(e) => {
                                        setPlateCurrent(e.target.value);
                                    }}
                                    disabled={!isHandlePlateChecked}
                                />
                                <IconButton
                                    className="visibility-password"
                                    disabled
                                    onMouseDown={(e: SyntheticEvent) => { }}
                                    edge="end"
                                    size="large"
                                >
                                    <PinOutlined />
                                </IconButton>
                            </FormControl>
                        </Box>
                    </Paper>

                    <Paper className="trv-container tw-rounded-xl tw-border-0 tw-bg-white tw-shadow-none" elevation={0} sx={style}>
                        <Box className="col-md-12" style={{ marginBottom: 20 }}>
                            <Autocomplete
                                id="chip-label-select-customer"
                                className="input-select-customer"
                                style={{
                                    width: "100%",
                                    minHeight: "56px",
                                    height: "56px",
                                    backgroundColor: "#ffffff29",
                                    borderColor: "lightgray",
                                }}
                                options={customersList}
                                value={!getCurrentUser.configs.isManager ? getCurrentUser.customer : customer}
                                onChange={(_, option) => {
                                    setCustomer(option ?? customerDefault);
                                }}
                                disabled={(!getCurrentUser.configs.isManager) || (isHandlePlateChecked)}
                                getOptionLabel={(option) => `${option.reducedName}`}
                                noOptionsText={"Nada encontrado"}
                                renderInput={(params) => (
                                    <>
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex" }}
                                        >
                                            <InputLabel
                                                id="country-label"
                                                required
                                                disabled={(!getCurrentUser.configs.isManager) || (isHandlePlateChecked)}
                                                style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                shrink
                                            >
                                                Cliente
                                            </InputLabel>
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder="Selecione um cliente"
                                                autoComplete="off"
                                                required
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    notched: true,
                                                    label: "Cliente",
                                                    classes: {
                                                        notchedOutline: "custom-notch",
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                    </>
                                )}
                            />
                        </Box>

                        <Box className="col-md-12" style={{ marginBottom: 20 }}>
                            <Autocomplete
                                id="chip-label-select-secretary"
                                className="input-select-secretary"
                                style={{
                                    width: "100%",
                                    minHeight: "56px",
                                    height: "56px",
                                    backgroundColor: "#ffffff29",
                                    borderColor: "lightgray",
                                }}
                                options={secretariesList}
                                value={(!getCurrentUser.configs.isManager && secretariesList.find((a) => a.reducedName === (currentParameters?.secretary?.reducedName))) || secretary}
                                onChange={(_, option) => {
                                    setSecretary(option ?? secretaryDefault);
                                }}
                                disabled={(!getCurrentUser.configs.isManager && !currentParameters?.isViewingAll) || (isHandlePlateChecked)}
                                getOptionLabel={(option) => `${option.reducedName}`}
                                noOptionsText={"Nada encontrado"}
                                renderInput={(params) => (
                                    <>
                                        <FormControl
                                            className="form-group"
                                            style={{ display: "flex" }}
                                        >
                                            <InputLabel
                                                id="country-label"
                                                required
                                                disabled={(!getCurrentUser.configs.isManager) || (isHandlePlateChecked)}
                                                style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                                shrink
                                            >
                                                Secretaria
                                            </InputLabel>
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder="Selecione uma secretaria"
                                                autoComplete="off"
                                                required
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    notched: true,
                                                    label: "Secretaria",
                                                    classes: {
                                                        notchedOutline: "custom-notch",
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                    </>
                                )}
                            />
                        </Box>
                    </Paper>
                </>
            ),
        },
        {
            label: "Origem",
            item: (
                <Paper className="trv-container tw-rounded-xl tw-border-0 tw-bg-white tw-shadow-none" elevation={0} sx={style}>
                    <Box className="col-md-12" style={{ marginBottom: 20 }}>
                        <Autocomplete
                            id="chip-label-select-department"
                            className="input-select-department"
                            style={{
                                width: "100%",
                                minHeight: "56px",
                                height: "56px",
                                backgroundColor: "#ffffff29",
                                borderColor: "lightgray",
                            }}
                            options={departmentsList}
                            value={(!getCurrentUser.configs.isManager && departmentsList.find((a) => a.reducedName === (currentParameters?.department?.reducedName))) || department}
                            onChange={(_, option) => {
                                setDepartment(option ?? departmentDefault);
                            }}
                            disabled={(!getCurrentUser.configs.isManager && !currentParameters?.isViewingAll) || (isHandlePlateChecked)}
                            getOptionLabel={(option) => `${option.reducedName}`}
                            noOptionsText={"Nada encontrado"}
                            renderInput={(params) => (
                                <>
                                    <FormControl
                                        className="form-group"
                                        style={{ display: "flex" }}
                                    >
                                        <InputLabel
                                            id="country-label"
                                            required
                                            disabled={(!getCurrentUser.configs.isManager && !currentParameters?.isViewingAll) || (isHandlePlateChecked)}
                                            style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                            shrink
                                        >
                                            Departamento
                                        </InputLabel>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            placeholder="Selecione um departamento"
                                            autoComplete="off"
                                            required
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                ...params.InputProps,
                                                notched: true,
                                                label: "Departamento",
                                                classes: {
                                                    notchedOutline: "custom-notch",
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </>
                            )}
                        />
                    </Box>

                    <Box className="col-md-12" style={{ margin: "15px 0px 15px 0px" }}>
                        <Autocomplete
                            id="chip-label-select-group"
                            className="input-select-group"
                            style={{
                                width: "100%",
                                minHeight: "56px",
                                height: "56px",
                                backgroundColor: "#ffffff29",
                                borderColor: "lightgray",
                            }}
                            options={vehicleList}
                            value={selectedVehicle ?? null}
                            onChange={(_, value) => {
                                setSelectedVehicle(value ?? null);
                            }}
                            disabled={(isHandlePlateChecked)}
                            getOptionLabel={(option) => option?.name ? `${option?.name} - ${option?.vehiclePlate}(${option?.deviceImei ?? option?.satelliteImei ?? "Sem dispositivo"})` : "Selecione um veículo"}
                            noOptionsText={"Nada encontrado"}
                            renderInput={(params) => (
                                <>
                                    <FormControl
                                        className="form-group"
                                        style={{ display: "flex" }}
                                    >
                                        <InputLabel
                                            id="state-label"
                                            required
                                            disabled={(isHandlePlateChecked)}
                                            style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                            shrink
                                        >
                                            Veículo
                                        </InputLabel>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            placeholder="Selecione um veículo"
                                            autoComplete="off"
                                            required
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                ...params.InputProps,
                                                notched: true,
                                                label: "Veículo",
                                                startAdornment: <LocalShippingRounded style={{ fill: `${vehicleList.find(v => v.name === selectedVehicle?.name)?.vehicleColorName ?? "gray"}` }} />,
                                                classes: {
                                                    notchedOutline: "custom-notch",
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </>
                            )}
                        />
                    </Box>
                </Paper>
            ),
        },
        {
            label: "Comando",
            item: (
                <Paper
                    className="trv-container tw-m-0 tw-rounded-xl tw-border-0 tw-bg-white tw-shadow-none"
                    sx={{ ...style, gridTemplateColumns: "minmax(0, 1fr)", justifyContent: "start", alignItems: "center", padding: { xs: 2, sm: 2.5 } }}
                >
                    <Box sx={commandFieldsStyle}>
                    {!isSetConfiDnsChecked && !isHandleCommandChecked && !isSetIbuttonChecked && !isSetOdometerChecked && !isSetApnChecked && !isSetSpeedLimitChecked && <Box className="col-md-12" style={{ marginBottom: 20 }}>
                        <Autocomplete
                            id="chip-label-select-command"
                            className="input-select-command"
                            style={{
                                width: "100%",
                                backgroundColor: "#ffffff29",
                                borderColor: "lightgray",
                            }}
                            onChange={(_, value) => {
                                setDeviceCommandName(value?.description ?? "");
                            }}
                            options={deviceCommandsList}
                            disabled={isHandleCommandChecked}
                            value={deviceCommandsList.find((a) => a.description === deviceCommandName) ?? null}
                            getOptionLabel={(option) => `${option.description} - (${option.type})`}
                            noOptionsText={"Nada encontrado"}
                            renderInput={(params) => (
                                <>
                                    <FormControl
                                        className="form-group"
                                        style={{ display: "flex" }}
                                    >
                                        <InputLabel
                                            id="vehicles-label"
                                            required={!isHandleCommandChecked}
                                            style={{ color: "rgba(0, 0, 0, 0.6)", fontFamily: "Prometo" }}
                                            shrink
                                        >
                                            Comando
                                        </InputLabel>
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            placeholder="Selecione uma comando"
                                            autoComplete="off"
                                            required={!isHandleCommandChecked}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                ...params.InputProps,
                                                notched: true,
                                                label: "Comando",
                                                classes: {
                                                    notchedOutline: "custom-notch",
                                                },
                                            }}
                                        />
                                    </FormControl>
                                </>
                            )}
                        />
                    </Box>}

                    {isSetConfiDnsChecked &&
                        <><Box className="col-md-12" style={{ marginBottom: 20 }}>
                            <FormControl
                                className="form-group"
                                style={{ display: "flex", width: "100%" }}
                            >
                                <InputLabel
                                    id="demo-multiple-name-label"
                                    shrink
                                    style={{ fontFamily: "Prometo" }}
                                    required
                                >
                                    DNS/IP
                                </InputLabel>
                                <TextField
                                    name="commandLine"
                                    InputProps={{
                                        label: "DNS/IP",
                                        notched: true,
                                        style: { fontFamily: "Prometo" },
                                    }}
                                    value={dns}
                                    onChange={(
                                        event: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        setDns(event.target.value)
                                    }}
                                    type="text"
                                    autoComplete="off"
                                    className="form-control form-control-login"
                                    placeholder="Digite o Dns ou Ip a ser usado"
                                    required
                                />
                                <IconButton
                                    className="visibility-password"
                                    disabled
                                    onMouseDown={(event: SyntheticEvent) => { }}
                                    edge="end"
                                    size="large"
                                >
                                    <SevenMpOutlined />
                                </IconButton>
                            </FormControl>
                        </Box>

                            <Box className="col-md-12" style={{ marginBottom: 20 }}>
                                <FormControl
                                    className="form-group"
                                    style={{ display: "flex", width: "100%" }}
                                >
                                    <InputLabel
                                        id="demo-multiple-name-label"
                                        shrink
                                        style={{ fontFamily: "Prometo" }}
                                        required
                                    >
                                        Porta
                                    </InputLabel>
                                    <TextField
                                        name="commandLine"
                                        InputProps={{
                                            label: "Porta",
                                            notched: true,
                                            style: { fontFamily: "Prometo" },
                                        }}
                                        value={port}
                                        onChange={(
                                            event: ChangeEvent<HTMLInputElement>
                                        ) => {
                                            setPort(event.target.value)
                                        }}
                                        type="text"
                                        autoComplete="off"
                                        className="form-control form-control-login"
                                        placeholder="Digite a porta"
                                        required
                                    />
                                    <IconButton
                                        className="visibility-password"
                                        disabled
                                        onMouseDown={(event: SyntheticEvent) => { }}
                                        edge="end"
                                        size="large"
                                    >
                                        <SevenMpOutlined />
                                    </IconButton>
                                </FormControl>
                            </Box>
                        </>}

                    {isSetApnChecked &&
                        <><Box className="col-md-12" style={{ marginBottom: 20 }}>
                            <FormControl
                                className="form-group"
                                style={{ display: "flex", width: "100%" }}
                            >
                                <InputLabel
                                    id="demo-multiple-name-label"
                                    shrink
                                    style={{ fontFamily: "Prometo" }}
                                    required
                                >
                                    APN
                                </InputLabel>
                                <TextField
                                    name="commandLine"
                                    InputProps={{
                                        label: "APN",
                                        notched: true,
                                        style: { fontFamily: "Prometo" },
                                    }}
                                    value={apn}
                                    onChange={(
                                        event: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        setApn(event.target.value)
                                    }}
                                    type="text"
                                    autoComplete="off"
                                    className="form-control form-control-login"
                                    placeholder="Digite a apn"
                                    required
                                />
                                <IconButton
                                    className="visibility-password"
                                    disabled
                                    onMouseDown={(event: SyntheticEvent) => { }}
                                    edge="end"
                                    size="large"
                                >
                                    <SevenMpOutlined />
                                </IconButton>
                            </FormControl>
                        </Box>

                            <Box className="col-md-12" style={{ marginBottom: 20 }}>
                                <FormControl
                                    className="form-group"
                                    style={{ display: "flex", width: "100%" }}
                                >
                                    <InputLabel
                                        id="demo-multiple-name-label"
                                        shrink
                                        style={{ fontFamily: "Prometo" }}
                                        required
                                    >
                                        Login
                                    </InputLabel>
                                    <TextField
                                        name="commandLine"
                                        InputProps={{
                                            label: "Login",
                                            notched: true,
                                            style: { fontFamily: "Prometo" },
                                        }}
                                        value={login}
                                        onChange={(
                                            event: ChangeEvent<HTMLInputElement>
                                        ) => {
                                            setLogin(event.target.value)
                                        }}
                                        type="text"
                                        autoComplete="off"
                                        className="form-control form-control-login"
                                        placeholder="Digite a login"
                                        required
                                    />
                                    <IconButton
                                        className="visibility-password"
                                        disabled
                                        onMouseDown={(event: SyntheticEvent) => { }}
                                        edge="end"
                                        size="large"
                                    >
                                        <SevenMpOutlined />
                                    </IconButton>
                                </FormControl>
                            </Box>

                            <Box className="col-md-12" style={{ marginBottom: 20 }}>
                                <FormControl
                                    className="form-group"
                                    style={{ display: "flex", width: "100%" }}
                                >
                                    <InputLabel
                                        id="demo-multiple-name-label"
                                        shrink
                                        style={{ fontFamily: "Prometo" }}
                                        required
                                    >
                                        Senha
                                    </InputLabel>
                                    <TextField
                                        name="commandLine"
                                        InputProps={{
                                            label: "Senha",
                                            notched: true,
                                            style: { fontFamily: "Prometo" },
                                        }}
                                        value={password}
                                        onChange={(
                                            event: ChangeEvent<HTMLInputElement>
                                        ) => {
                                            setPassword(event.target.value)
                                        }}
                                        type="text"
                                        autoComplete="off"
                                        className="form-control form-control-login"
                                        placeholder="Digite a senha"
                                        required
                                    />
                                    <IconButton
                                        className="visibility-password"
                                        disabled
                                        onMouseDown={(event: SyntheticEvent) => { }}
                                        edge="end"
                                        size="large"
                                    >
                                        <SevenMpOutlined />
                                    </IconButton>
                                </FormControl>
                            </Box>
                        </>}

                    {isSetSpeedLimitChecked &&
                        <><Box className="col-md-12" style={{ marginBottom: 20 }}>
                            <FormControl
                                className="form-group"
                                style={{ display: "flex", width: "100%" }}
                            >
                                <InputLabel
                                    id="demo-multiple-name-label"
                                    shrink
                                    style={{ fontFamily: "Prometo" }}
                                    required
                                >
                                    Limite
                                </InputLabel>
                                <TextField
                                    name="commandLine"
                                    InputProps={{
                                        label: "Limite",
                                        notched: true,
                                        style: { fontFamily: "Prometo" },
                                    }}
                                    value={speedLimit}
                                    onChange={(
                                        event: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        setSpeedLimit(event.target.value)
                                    }}
                                    type="text"
                                    autoComplete="off"
                                    className="form-control form-control-login"
                                    placeholder="Digite o valor em Km"
                                    required
                                />
                                <IconButton
                                    className="visibility-password"
                                    disabled
                                    onMouseDown={(event: SyntheticEvent) => { }}
                                    edge="end"
                                    size="large"
                                >
                                    <SevenMpOutlined />
                                </IconButton>
                            </FormControl>
                        </Box>

                            <Box className="col-md-12" style={{ marginBottom: 20 }}>
                                <FormControl
                                    className="form-group"
                                    style={{ display: "flex", width: "100%" }}
                                >
                                    <InputLabel
                                        id="demo-multiple-name-label"
                                        shrink
                                        style={{ fontFamily: "Prometo" }}
                                        required
                                    >
                                        Saída
                                    </InputLabel>
                                    <TextField
                                        name="commandLine"
                                        InputProps={{
                                            label: "Saída",
                                            notched: true,
                                            style: { fontFamily: "Prometo" },
                                        }}
                                        value={digout}
                                        onChange={(
                                            event: ChangeEvent<HTMLInputElement>
                                        ) => {
                                            setDigOut(event.target.value)
                                        }}
                                        type="text"
                                        autoComplete="off"
                                        className="form-control form-control-login"
                                        placeholder="Digite a saída ser ativada"
                                        required
                                    />
                                    <IconButton
                                        className="visibility-password"
                                        disabled
                                        onMouseDown={(event: SyntheticEvent) => { }}
                                        edge="end"
                                        size="large"
                                    >
                                        <SevenMpOutlined />
                                    </IconButton>
                                </FormControl>
                            </Box>

                            <Box className="col-md-12" style={{ marginBottom: 20 }}>
                                <FormControl
                                    className="form-group"
                                    style={{ display: "flex", width: "100%" }}
                                >
                                    <InputLabel
                                        id="demo-multiple-name-label"
                                        shrink
                                        style={{ fontFamily: "Prometo" }}
                                        required
                                    >
                                        Tempo de alarme
                                    </InputLabel>
                                    <TextField
                                        name="commandLine"
                                        InputProps={{
                                            label: "Tempo de alarme",
                                            notched: true,
                                            style: { fontFamily: "Prometo" },
                                        }}
                                        value={alarmTime}
                                        onChange={(
                                            event: ChangeEvent<HTMLInputElement>
                                        ) => {
                                            setAlarmTime(event.target.value)
                                        }}
                                        type="text"
                                        autoComplete="off"
                                        className="form-control form-control-login"
                                        placeholder="Digite o tempo que o Buzzer vai ficar em alarme"
                                        required
                                    />
                                    <IconButton
                                        className="visibility-password"
                                        disabled
                                        onMouseDown={(event: SyntheticEvent) => { }}
                                        edge="end"
                                        size="large"
                                    >
                                        <SevenMpOutlined />
                                    </IconButton>
                                </FormControl>
                            </Box>
                        </>}

                    {isSetOdometerChecked &&
                        <Box className="col-md-12" style={{ marginBottom: 20 }}>
                            <FormControl
                                className="form-group"
                                style={{ display: "flex", width: "100%" }}
                            >
                                <InputLabel
                                    id="demo-multiple-name-label"
                                    shrink
                                    style={{ fontFamily: "Prometo" }}
                                    required
                                >
                                    Odometro
                                </InputLabel>
                                <TextField
                                    name="commandLine"
                                    InputProps={{
                                        label: "Odometro",
                                        notched: true,
                                        style: { fontFamily: "Prometo" },
                                    }}
                                    value={odometerValue}
                                    onChange={(
                                        event: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        setOdometerValue(event.target.value)
                                    }}
                                    type="text"
                                    autoComplete="off"
                                    className="form-control form-control-login"
                                    placeholder="Digite o valor do odometro em Km"
                                    required
                                />
                                <IconButton
                                    className="visibility-password"
                                    disabled
                                    onMouseDown={(event: SyntheticEvent) => { }}
                                    edge="end"
                                    size="large"
                                >
                                    <SevenMpOutlined />
                                </IconButton>
                            </FormControl>
                        </Box>}

                    {isHandleCommandChecked && <Box className="col-md-12" style={{ marginBottom: 20 }}>
                        <FormControl
                            className="form-group"
                            style={{ display: "flex", width: "100%" }}
                        >
                            <InputLabel
                                id="demo-multiple-name-label"
                                shrink
                                style={{ fontFamily: "Prometo" }}
                                required
                            >
                                Linha de comando
                            </InputLabel>
                            <TextField
                                name="commandLine"
                                InputProps={{
                                    label: "Linha de comando",
                                    notched: true,
                                    style: { fontFamily: "Prometo" },
                                }}
                                value={handleCommandLine}
                                onChange={(
                                    event: ChangeEvent<HTMLInputElement>
                                ) => {
                                    setHandleCommandLine(event.target.value)
                                }}
                                type="text"
                                autoComplete="off"
                                className="form-control form-control-login"
                                placeholder="Digite a linha de comando"
                                required
                            />
                            <IconButton
                                className="visibility-password"
                                disabled
                                onMouseDown={(event: SyntheticEvent) => { }}
                                edge="end"
                                size="large"
                            >
                                <AbcOutlined />
                            </IconButton>
                        </FormControl>
                    </Box>}

                    {isSetIbuttonChecked && <>
                        <Box className="col-md-8" style={{ marginBottom: 20 }}>
                            <FormControl
                                className="form-group"
                                style={{ display: "flex", width: "100%" }}
                            >
                                <InputLabel
                                    id="demo-multiple-name-label"
                                    shrink
                                    style={{ fontFamily: "Prometo" }}
                                    required
                                >
                                    Identificadores
                                </InputLabel>
                                <TextField
                                    name="commandLine"
                                    InputProps={{
                                        label: "Identificadores",
                                        notched: true,
                                        style: { fontFamily: "Prometo" },
                                    }}
                                    value={identifiers}
                                    onChange={(
                                        event: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        setIdentifiers(event.target.value)
                                    }}
                                    type="text"
                                    autoComplete="off"
                                    className="form-control form-control-login"
                                    placeholder="Digite um ou mais identificadores"
                                    required
                                />
                                <IconButton
                                    className="visibility-password"
                                    disabled
                                    onMouseDown={(event: SyntheticEvent) => { }}
                                    edge="end"
                                    size="large"
                                >
                                    <AbcOutlined />
                                </IconButton>
                            </FormControl>
                        </Box>

                        <Box className="col-md-4" style={{ marginBottom: 20 }}>
                            <FormControl
                                className="form-group"
                                style={{ display: "flex", width: "100%" }}
                            >
                                <InputLabel
                                    id="demo-multiple-name-label"
                                    shrink
                                    style={{ fontFamily: "Prometo" }}
                                    required
                                >
                                    Porta inicio
                                </InputLabel>
                                <TextField
                                    name="commandLine"
                                    InputProps={{
                                        label: "Porta inicio",
                                        notched: true,
                                        style: { fontFamily: "Prometo" },
                                    }}
                                    value={identifierPort}
                                    onChange={(
                                        event: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        setIdentifierPort(event.target.value)
                                    }}
                                    type="text"
                                    autoComplete="off"
                                    className="form-control form-control-login"
                                    placeholder="Digite a porta"
                                    required
                                />
                                <IconButton
                                    className="visibility-password"
                                    disabled
                                    onMouseDown={(event: SyntheticEvent) => { }}
                                    edge="end"
                                    size="large"
                                >
                                    <SevenMpOutlined />
                                </IconButton>
                            </FormControl>
                        </Box>
                    </>}

                    </Box>

                    <Box className="command-options-grid" sx={commandOptionsStyle}>
                        <Typography
                            variant="caption"
                            sx={{
                                gridColumn: "1 / -1",
                                color: "#475569",
                                fontFamily: "Prometo",
                                fontWeight: 700,
                                letterSpacing: "0.06em",
                                textTransform: "uppercase",
                            }}
                        >
                            Opções do comando
                        </Typography>
                        <Box className="col-md-3" style={{ marginBottom: 15, alignItems: 'end' }}>
                            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                <IOSSwitch
                                    checked={isSetOdometerChecked}
                                    onChange={(event) => {
                                        const checked = event.target.checked;

                                        if (!checked) {
                                            setOdometerValue("");
                                        }

                                        setHandleCommandLine("");
                                        setSpeedLimit("");
                                        setDigOut("");
                                        setAlarmTime("");
                                        setIdentifierPort("");
                                        setIdentifiers("");
                                        setApn("");
                                        setLogin("");
                                        setPassword("");
                                        setDns("");
                                        setPort("");

                                        setIsHandleCommandChecked(false);
                                        setIsSetSpeedChecked(false);
                                        setIsSetIbuttonChecked(false);
                                        setIsSetApnChecked(false);
                                        SetIsSetConfiDnsChecked(false);

                                        setIsSetOdometerChecked(checked);
                                    }}
                                    inputProps={{ 'aria-label': 'ant design' }}
                                />
                                <Typography>Atualizar odômetro</Typography>
                            </Stack>
                        </Box>

                        <Box className="col-md-3" style={{ marginBottom: 15, alignItems: 'end' }}>
                            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                <IOSSwitch
                                    checked={isSetSpeedLimitChecked}
                                    onChange={(event) => {
                                        const checked = event.target.checked;

                                        if (!checked) {
                                            setSpeedLimit("");
                                            setDigOut("");
                                            setAlarmTime("");
                                        }

                                        setOdometerValue("");
                                        setHandleCommandLine("");
                                        setIdentifierPort("");
                                        setIdentifiers("");
                                        setApn("");
                                        setLogin("");
                                        setPassword("");
                                        setDns("");
                                        setPort("");

                                        setIsHandleCommandChecked(false);
                                        setIsSetIbuttonChecked(false);
                                        setIsSetApnChecked(false);
                                        SetIsSetConfiDnsChecked(false);
                                        setIsSetOdometerChecked(false);

                                        setIsSetSpeedChecked(checked);

                                    }}
                                    inputProps={{ 'aria-label': 'ant design' }}
                                />
                                <Typography>Limite de velocidade</Typography>
                            </Stack>
                        </Box>

                        {getCurrentUser.configs.isManager && <Box className="col-md-3" style={{ marginBottom: 15, alignItems: 'end' }}>
                            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                <IOSSwitch
                                    checked={isSetIbuttonChecked}
                                    onChange={(event) => {
                                        const checked = event.target.checked;

                                        if (!checked) {
                                            setIdentifierPort("");
                                            setIdentifiers("");
                                        }

                                        setSpeedLimit("");
                                        setDigOut("");
                                        setAlarmTime("");
                                        setOdometerValue("");

                                        setHandleCommandLine("");
                                        setApn("");
                                        setLogin("");
                                        setPassword("");
                                        setDns("");
                                        setPort("");

                                        setIsHandleCommandChecked(false);
                                        setIsSetApnChecked(false);
                                        SetIsSetConfiDnsChecked(false);
                                        setIsSetOdometerChecked(false);
                                        setIsSetSpeedChecked(false);

                                        setIsSetIbuttonChecked(checked);

                                    }}
                                    inputProps={{ 'aria-label': 'ant design' }}
                                />
                                <Typography>Inserir identificador</Typography>
                            </Stack>
                        </Box>}

                        {getCurrentUser.configs.isManager && <Box className="col-md-3" style={{ marginBottom: 15, alignItems: 'end' }}>
                            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                <IOSSwitch
                                    checked={isSetApnChecked}
                                    onChange={(event) => {
                                        const checked = event.target.checked;

                                        if (!checked) {
                                            setApn("");
                                            setLogin("");
                                            setPassword("");
                                        }

                                        setSpeedLimit("");
                                        setDigOut("");
                                        setAlarmTime("");
                                        setOdometerValue("");
                                        setIdentifierPort("");
                                        setIdentifiers("");
                                        setHandleCommandLine("");
                                        setDns("");
                                        setPort("");

                                        setIsHandleCommandChecked(false);
                                        SetIsSetConfiDnsChecked(false);
                                        setIsSetOdometerChecked(false);
                                        setIsSetSpeedChecked(false);
                                        setIsSetIbuttonChecked(false);
                                        setIsSetApnChecked(checked);

                                    }}
                                    inputProps={{ 'aria-label': 'ant design' }}
                                />
                                <Typography>Configurar APN</Typography>
                            </Stack>
                        </Box>}

                        {getCurrentUser.configs.isManager && <Box className="col-md-3" style={{ marginBottom: 15, alignItems: 'end' }}>
                            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                <IOSSwitch
                                    checked={isSetConfiDnsChecked}
                                    onChange={(event) => {
                                        const checked = event.target.checked;

                                        if (!checked) {
                                            setDns("");
                                            setPort("");
                                        }

                                        setSpeedLimit("");
                                        setDigOut("");
                                        setAlarmTime("");
                                        setOdometerValue("");
                                        setIdentifierPort("");
                                        setIdentifiers("");
                                        setHandleCommandLine("");
                                        setApn("");
                                        setLogin("");
                                        setPassword("");

                                        setIsHandleCommandChecked(false);
                                        setIsSetOdometerChecked(false);
                                        setIsSetSpeedChecked(false);
                                        setIsSetIbuttonChecked(false);
                                        setIsSetApnChecked(false);

                                        SetIsSetConfiDnsChecked(checked);

                                    }}
                                    inputProps={{ 'aria-label': 'ant design' }}
                                />
                                <Typography>Configurar IP e porta</Typography>
                            </Stack>
                        </Box>}

                        {getCurrentUser.configs.isManager && <Box className="col-md-3" style={{ marginBottom: 15, alignItems: 'end' }}>
                            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                                <IOSSwitch
                                    checked={isHandleCommandChecked}
                                    onChange={(event) => {
                                        const checked = event.target.checked;

                                        if (!checked) {
                                            setHandleCommandLine("");
                                        }

                                        setSpeedLimit("");
                                        setDigOut("");
                                        setAlarmTime("");
                                        setOdometerValue("");
                                        setIdentifierPort("");
                                        setIdentifiers("");
                                        setApn("");
                                        setLogin("");
                                        setPassword("");
                                        setDns("");
                                        setPort("");

                                        setIsSetOdometerChecked(false);
                                        setIsSetSpeedChecked(false);
                                        SetIsSetConfiDnsChecked(false);
                                        setIsSetIbuttonChecked(false);
                                        setIsSetApnChecked(false);
                                        setIsHandleCommandChecked(checked);

                                    }}
                                    inputProps={{ 'aria-label': 'ant design' }}
                                />
                                <Typography>Envio manual</Typography>
                            </Stack>
                        </Box>}
                    </Box>
                </Paper>
            ),
        },
    ], [
        IOSSwitch,
        getCurrentUser.customer,
        handleCommandLine,
        currentParameters?.isViewingAll,
        currentParameters?.department?.reducedName,
        currentParameters?.secretary?.reducedName,
        customer,
        customersList,
        department,
        departmentsList,
        deviceCommandName,
        deviceCommandsList,
        getCurrentUser.configs.isManager,
        isHandleCommandChecked,
        secretariesList,
        secretary,
        selectedVehicle,
        vehicleList,
        plateCurrent,
        isHandlePlateChecked,
        isSetIbuttonChecked,
        isSetOdometerChecked,
        isSetSpeedLimitChecked,
        isSetApnChecked,
        isSetConfiDnsChecked,
        identifierPort,
        odometerValue,
        alarmTime,
        apn,
        digout,
        dns,
        identifiers,
        login,
        password,
        port,
        speedLimit,
        commandResult,
        loading
    ]);

    return (
        <>
            <Toast
                ref={toastRef}
                position="center"
                style={{ zIndex: 99999 }}
                onShow={() => {
                    setIsToastVisible(true);

                    if (validationText) {
                        setTimeout(() => {
                            setFieldsIsValid(true);
                            setIsToastVisible(false);
                        }, 3000);
                    }
                }}
            />
            <Box
                className="container-fluid tw-w-full tw-rounded-xl tw-bg-white tw-px-0 tw-py-2"
                sx={{ background: "#fff", borderRadius: 3, minHeight: 0, height: "auto", overflow: "visible", position: "relative" }}
            >
                {isSendingCommand && (
                    <Box
                        sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "rgba(255, 255, 255, 0.90)",
                            backdropFilter: "blur(3px)",
                            zIndex: 10,
                            borderRadius: 3,
                            gap: 2,
                        }}
                    >
                        <CircularProgress size={40} sx={{ color: "#0FB403" }} />
                        <Typography
                            variant="body2"
                            sx={{
                                fontFamily: "Prometo",
                                color: "#333",
                                fontWeight: 600,
                                textAlign: "center",
                            }}
                        >
                            Aguardando resposta do comando...
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{
                                fontFamily: "Prometo",
                                color: "#888",
                                textAlign: "center",
                            }}
                        >
                            Isso pode levar até 1 minuto
                        </Typography>
                    </Box>
                )}
                <Stepper
                    activeStep={activeStep}
                    orientation="vertical"
                    sx={{
                        background: "",
                        width: "100%",
                        maxWidth: "none",
                        margin: 0,
                        "& .MuiStepContent-root": { paddingLeft: { xs: 1, sm: 2 }, paddingRight: 0 },
                        "& .Mui-active": {
                            fill: "#003f4a",
                        },
                        "& .Mui-completed": {
                            fill: "#00b700",
                            color: "#ffff",
                        },
                    }}
                >
                    {steps.map((step, index) => (
                        <Step key={step.label}>
                            <StepLabel
                                optional={
                                    index === steps.length - 1 ? (
                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <Typography variant="caption">
                                                Selecione o comando a ser enviado
                                            </Typography>
                                            {(selectedVehicle?.vehiclePlate || plateCurrent) && (
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        fontFamily: "Prometo",
                                                        fontWeight: 600,
                                                        color: "#003f4a",
                                                        backgroundColor: "#e0f2f1",
                                                        borderRadius: 1,
                                                        px: 1.5,
                                                        py: 0.3,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 0.5,
                                                    }}
                                                >
                                                    <LocalShippingRounded sx={{ fontSize: 14, color: "#00796b" }} />
                                                    {selectedVehicle?.vehiclePlate
                                                        ? `${selectedVehicle.name} - ${selectedVehicle.vehiclePlate}`
                                                        : plateCurrent}
                                                </Typography>
                                            )}
                                        </Box>
                                    ) : index === 0 ? (
                                        <Typography variant="caption">
                                            Selecione o cliente e a secretaria ou digite a placa do veículo
                                        </Typography>
                                    ) : index === 1 ? (
                                        <Typography variant="caption">
                                            Selecione o departamento e o veículo (dispositivo)
                                        </Typography>
                                    ) : null
                                }
                            >
                                {step.label}
                            </StepLabel>
                            <StepContent>
                                {step.item}
                                <Paper
                                    elevation={0}
                                    className="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-start tw-gap-2 tw-border-t tw-border-slate-200 tw-pt-3"
                                    sx={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                        width: "100%",
                                        gap: 1,
                                        background: "transparent",
                                        marginTop: 1.5,
                                        paddingTop: 1.5,
                                        borderTop: "1px solid #e2e8f0",
                                    }}
                                >
                                    <Button
                                        type="button"
                                        style={{
                                            fontFamily: "Prometo",
                                            color: "#ffff",
                                        }}
                                        onClick={
                                            () => {
                                                if (index === steps.length - 1) {
                                                    onSendCommand();
                                                } else {
                                                    handleNext();
                                                }
                                            }
                                        }
                                        className="tw-transition-all tw-duration-200 hover:tw-translate-y-[-1px]"
                                        sx={{ ...commandActionButtonStyle, order: 5, backgroundColor: "#00B700", "&:hover": { backgroundColor: "#009900", boxShadow: "0 6px 14px rgba(0,183,0,0.20)" } }}
                                        disabled={
                                            loading ||
                                            (index === 0 && !currentParameters?.secretary.name && !secretary.name) ||
                                            (index === 1 && (!isHandlePlateChecked && !selectedVehicle?.name) || (!isHandlePlateChecked && selectedVehicle?.satelliteImei && !selectedVehicle?.deviceImei)) ||
                                            (index === 2 && (deviceCommandName === "" && handleCommandLine === ""))
                                        }
                                    >
                                        {index === steps.length - 1 ? <SendToMobileOutlined style={{ marginRight: 5 }} /> : <ArrowForwardOutlined style={{ marginRight: 5 }} />}

                                        <Typography
                                            className="forgot-password"
                                            style={{
                                                fontFamily: "Prometo",
                                                fontSize: "16px",
                                                color: "#ffff",
                                            }}
                                        >
                                            {index === steps.length - 1 ? "Enviar" : "Próximo"}
                                        </Typography>
                                    </Button>

                                    <Button
                                        type="button"
                                        style={{
                                            fontFamily: "Prometo",
                                            color: "#ffff",
                                        }}
                                        onClick={handleBack}
                                        disabled={index === 0}
                                        className="tw-transition-all tw-duration-200 hover:tw-translate-y-[-1px]"
                                        sx={{ ...commandActionButtonStyle, order: 4, marginLeft: { xs: 0, sm: "auto" }, backgroundColor: "#dc3545", "&:hover": { backgroundColor: "#c82333", boxShadow: "0 6px 14px rgba(220,53,69,0.18)" } }}
                                    >
                                        <UndoOutlined style={{ marginRight: 5 }} />
                                        <Typography
                                            className="forgot-password"
                                            style={{
                                                fontFamily: "Prometo",
                                                fontSize: "16px",
                                                color: "#ffff",
                                            }}
                                        >
                                            {"Voltar"}
                                        </Typography>
                                    </Button>

                                    <Button
                                        type="button"
                                        style={{
                                            fontFamily: "Prometo",
                                            color: "#ffff",
                                        }}
                                        onClick={() => handleClose()}
                                        disabled={index === 0}
                                        className="tw-transition-all tw-duration-200 hover:tw-translate-y-[-1px]"
                                        sx={{ ...commandActionButtonStyle, order: 1, backgroundColor: "#dc3545", "&:hover": { backgroundColor: "#c82333", boxShadow: "0 6px 14px rgba(220,53,69,0.18)" } }}
                                    >
                                        <CachedOutlined style={{ marginRight: 5 }} />
                                        <Typography
                                            className="forgot-password"
                                            style={{
                                                fontFamily: "Prometo",
                                                fontSize: "16px",
                                                color: "#ffff",
                                            }}
                                        >
                                            {"Limpar"}
                                        </Typography>
                                    </Button>

                                    <Button
                                        type="button"
                                        style={{
                                            fontFamily: "Prometo",
                                            color: "#ffff",
                                        }}
                                        onClick={toggleDrawer(true)}
                                        disabled={index !== steps.length - 1}
                                        className="tw-transition-all tw-duration-200 hover:tw-translate-y-[-1px]"
                                        sx={{ ...commandActionButtonStyle, order: 2, backgroundColor: "#098bf5", "&:hover": { backgroundColor: "#0878d1", boxShadow: "0 6px 14px rgba(9,139,245,0.18)" } }}
                                    >
                                        <ArticleOutlined style={{ marginRight: 5 }} />
                                        <Typography
                                            className="forgot-password"
                                            style={{
                                                fontFamily: "Prometo",
                                                fontSize: "16px",
                                                color: "#ffff",
                                            }}
                                        >
                                            {"Logs"}
                                        </Typography>
                                    </Button>

                                    <Button
                                        type="button"
                                        style={{
                                            fontFamily: "Prometo",
                                            color: "#ffff",
                                        }}
                                        onClick={toggleQueueDrawer(true)}
                                        disabled={index !== steps.length - 1 || !selectedVehicle?.deviceId}
                                        className="tw-transition-all tw-duration-200 hover:tw-translate-y-[-1px]"
                                        sx={{ ...commandActionButtonStyle, order: 3, backgroundColor: "#003f4a", "&:hover": { backgroundColor: "#09414A", boxShadow: "0 6px 14px rgba(0,63,74,0.20)" } }}
                                    >
                                        <ListAltOutlined style={{ marginRight: 5 }} />
                                        <Typography
                                            className="forgot-password"
                                            style={{
                                                fontFamily: "Prometo",
                                                fontSize: "16px",
                                                color: "#ffff",
                                            }}
                                        >
                                            {"Fila"}
                                        </Typography>
                                    </Button>
                                </Paper>

                                {index === 2 && (
                                    <Box sx={{
                                        mt: 2,
                                        mb: 1,
                                        opacity: (isSetSpeedLimitChecked || isSetApnChecked || isSetConfiDnsChecked) ? 0.0 : 1,
                                        transition: 'opacity 0.3s ease',
                                        pointerEvents: (isSetSpeedLimitChecked || isSetApnChecked || isSetConfiDnsChecked) ? 'none' : 'auto'
                                    }}>
                                        {mqttCommandDelivery ? (
                                            <Alert
                                                severity={mqttCommandStatusInfo.severity === "warn" ? "warning" : mqttCommandStatusInfo.severity}
                                                action={
                                                    <IconButton
                                                        color="inherit"
                                                        size="small"
                                                        title="Atualizar status"
                                                        onClick={() => void refreshMqttCommandDelivery()}
                                                    >
                                                        <Refresh fontSize="small" />
                                                    </IconButton>
                                                }
                                                sx={{
                                                    alignItems: "flex-start",
                                                    ...getMqttCommandStatusCardStyle(mqttCommandStatusInfo.severity),
                                                }}
                                            >
                                                <Typography variant="body2" sx={{ fontWeight: "bold", fontFamily: "Prometo" }}>
                                                    {mqttCommandStatusInfo.label}
                                                </Typography>
                                                <Typography variant="caption" display="block" sx={{ fontFamily: "Prometo" }}>
                                                    Comando: {mqttCommandDelivery.description || "Não informado"}
                                                </Typography>
                                                <Typography variant="caption" display="block" sx={{ fontFamily: "Prometo" }}>
                                                    ID do envio: {mqttCommandDelivery.commandId}
                                                </Typography>
                                                {mqttCommandDelivery.response && (
                                                    <Typography variant="caption" display="block" sx={{ fontFamily: "Prometo" }}>
                                                        Resposta: {mqttCommandDelivery.response}
                                                    </Typography>
                                                )}
                                                {mqttCommandDelivery.error && (
                                                    <Typography variant="caption" display="block" sx={{ fontFamily: "Prometo" }}>
                                                        Erro: {mqttCommandDelivery.error}
                                                    </Typography>
                                                )}
                                                {mqttCommandDelivery.respondedAt && (
                                                    <Typography variant="caption" display="block" sx={{ fontFamily: "Prometo" }}>
                                                        Atualizado em: {mqttCommandDelivery.respondedAt}
                                                    </Typography>
                                                )}
                                            </Alert>
                                        ) : loading ? (
                                            <Skeleton variant="rectangular" height={80} sx={{ borderRadius: 2 }} />
                                        ) : commandResult.length > 0 ? (
                                            (() => {
                                                const lastLog = commandResult[0];
                                                const logInfo = getLogInfo(lastLog);
                                                if (!logInfo) return null;
                                                const logStatusInfo = getMqttCommandStatusInfo(
                                                    logInfo.status ?? "RESPONDED"
                                                );
                                                const logStatusColor = mqttCommandStatusPalette[logStatusInfo.severity].main;

                                                return (
                                                    <Paper
                                                        elevation={0}
                                                        sx={{
                                                            p: 2,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: 0.5,
                                                            ...getMqttCommandStatusCardStyle(logStatusInfo.severity),
                                                        }}
                                                    >
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <Typography variant="caption" sx={{ fontWeight: 'bold', color: logStatusColor, fontFamily: 'Prometo' }}>
                                                                ÚLTIMO RESULTADO DE COMANDO
                                                            </Typography>
                                                            <Typography variant="caption" color="textSecondary" sx={{ fontFamily: 'Prometo' }}>
                                                                {lastLog.eventDateTime || "-"}
                                                            </Typography>
                                                        </Box>
                                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#003f4a', fontFamily: 'Prometo' }}>
                                                            {logInfo.displayName}
                                                        </Typography>
                                                        {logInfo.logData && (
                                                            <Typography variant="caption" sx={{ color: '#003f4a', opacity: 0.7, fontFamily: 'Prometo', fontStyle: 'italic' }}>
                                                                Comando: {logInfo.logData}
                                                            </Typography>
                                                        )}
                                                        {logInfo.displayDescription && (
                                                            <Typography variant="caption" sx={{ color: '#003f4a', opacity: 0.8, fontFamily: 'Prometo' }}>
                                                                {logInfo.displayDescriptionLabel}: {logInfo.displayDescription}
                                                            </Typography>
                                                        )}
                                                        {logInfo.commandId && (
                                                            <Typography variant="caption" color="textSecondary" display="block" sx={{ fontFamily: 'Prometo' }}>
                                                                ID do envio: {logInfo.commandId}
                                                            </Typography>
                                                        )}
                                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
                                                            <IconButton
                                                                size="small"
                                                                disabled={isCommandResultLoading}
                                                                onClick={() => getLastFiveCommandResult(cookies.token || sessionStorage.getItem("token") || "", false)}
                                                                sx={{ color: logStatusColor, p: 0.5 }}
                                                                title="Atualizar log"
                                                            >
                                                                <Refresh fontSize="small" />
                                                            </IconButton>
                                                        </Box>
                                                    </Paper>
                                                );
                                            })()
                                        ) : (
                                            <Paper
                                                elevation={0}
                                                sx={{
                                                    p: 2,
                                                    borderRadius: 2,
                                                    border: '2px dashed orange',
                                                    backgroundColor: 'rgba(255, 165, 0, 0.05)',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                <Typography variant="body2" sx={{ color: 'gray', fontFamily: 'Prometo' }}>
                                                    Nenhum resultado de comando disponível.
                                                </Typography>
                                            </Paper>
                                        )}
                                    </Box>
                                )}

                                {index === 2 && !isSendingCommand && <Box
                                    className="tw-w-full tw-py-2.5"
                                >
                                    <SwipeableDrawer
                                        anchor="bottom"
                                        open={open}
                                        onClose={toggleDrawer(false)}
                                        onOpen={toggleDrawer(true)}
                                        swipeAreaWidth={drawerBleeding}
                                        disableSwipeToOpen={false}
                                        PaperProps={{
                                            className: "tw-overflow-hidden tw-rounded-2xl tw-border-0 tw-bg-white tw-shadow-none",
                                            sx: {
                                                width: { xs: "calc(100% - 16px)", md: "min(92vw, 980px)" },
                                                maxHeight: "min(72dvh, 620px)",
                                                left: 0,
                                                right: 0,
                                                bottom: { xs: 72, sm: 88 },
                                                marginLeft: "auto",
                                                marginRight: "auto",
                                                borderRadius: 4,
                                                padding: 0,
                                                overflow: "hidden",
                                                backgroundColor: "#fff",
                                                boxShadow: "none",
                                            },
                                        }}
                                    >
                                        <Box
                                            className="tw-relative tw-overflow-hidden tw-bg-white tw-font-prometo"
                                            sx={{
                                                marginTop: 0,
                                                position: 'relative',
                                                visibility: open ? 'visible' : 'hidden'
                                            }}
                                        >
                                            <Puller />
                                            <FormControl
                                                className="tw-w-full"
                                                style={{ display: "flex", width: "100%", marginBottom: 5 }}
                                            >
                                                <Box
                                                    className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-3 tw-bg-gtr-sidebar tw-px-4 tw-pb-3 tw-pt-5 tw-text-white"
                                                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", backgroundColor: "#09414A" }}
                                                >
                                                    <InputLabel
                                                        shrink
                                                        style={{ color: "#fff", fontFamily: "Prometo", fontSize: 17, fontWeight: 700, position: 'relative', transform: 'none', marginBottom: 0 }}
                                                    >
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                            <ArticleOutlined fontSize="small" />
                                                            Log de comandos
                                                        </Box>
                                                    </InputLabel>
                                                    <Box className="tw-flex tw-items-center tw-gap-1">
                                                        <Tooltip title="Atualizar logs" arrow>
                                                            <span>
                                                                <IconButton
                                                                    aria-label="Atualizar logs de comandos"
                                                                    disabled={isCommandResultLoading}
                                                                    onClick={() => getLastFiveCommandResult(cookies.token || sessionStorage.getItem("token") || "")}
                                                                    size="small"
                                                                    sx={{ color: "#fff", "&:hover": { backgroundColor: "rgba(255,255,255,0.12)" } }}
                                                                >
                                                                    <Refresh />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                        <Tooltip title="Limpar logs" arrow>
                                                            <IconButton
                                                                aria-label="Limpar logs de comandos"
                                                                onClick={() => {
                                                                    cancelCommandResultRequest();
                                                                    setCommandResult([]);
                                                                }}
                                                                size="small"
                                                                sx={{ color: "#fff", "&:hover": { backgroundColor: "rgba(255,255,255,0.12)" } }}
                                                            >
                                                                <AutoDeleteOutlined />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Fechar" arrow>
                                                            <IconButton
                                                                aria-label="Fechar logs de comandos"
                                                                onClick={toggleDrawer(false)}
                                                                size="small"
                                                                sx={{ color: "#fff", "&:hover": { backgroundColor: "rgba(255,255,255,0.12)" } }}
                                                            >
                                                                <CloseOutlined />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Box>
                                                </Box>
                                                {isCommandResultLoading && (
                                                    <LinearProgress
                                                        color="success"
                                                        variant="indeterminate"
                                                    />
                                                )}
                                                <Box className="tw-bg-slate-50 tw-p-3 sm:tw-p-4" sx={{ position: 'relative' }}>
                                                    <Box sx={{
                                                        width: "100%",
                                                        maxHeight: "300px",
                                                        background: "transparent",
                                                        padding: 0,
                                                        scrollBehavior: "auto",
                                                        overflowY: "auto",
                                                        borderRadius: 0,
                                                        border: 'none',
                                                        /* Firefox */
                                                        scrollbarWidth: "thin",
                                                        scrollbarColor: "#c1c1c1 transparent",

                                                        /* Chrome, Edge, Safari */
                                                        "&::-webkit-scrollbar": {
                                                            width: "6px",
                                                        },
                                                        "&::-webkit-scrollbar-track": {
                                                            background: "transparent",
                                                        },
                                                        "&::-webkit-scrollbar-thumb": {
                                                            backgroundColor: "#c1c1c1",
                                                            borderRadius: "8px",
                                                        },
                                                        "&::-webkit-scrollbar-thumb:hover": {
                                                            backgroundColor: "#a0a0a0",
                                                        },
                                                    }}>
                                                        {open && isCommandResultLoading && commandResult.length === 0 ? (
                                                            <Stack spacing={2} sx={{ mb: 2 }}>
                                                                {[1, 2, 3].map((i) => (
                                                                    <Skeleton key={i} variant="rectangular" height={100} sx={{ borderRadius: 1 }} />
                                                                ))}
                                                            </Stack>
                                                        ) : commandResult.length > 0 ? (
                                                            <Stack spacing={1.25}>
                                                                {commandResult.map((item, idx) => {
                                                                    const logInfo = getLogInfo(item);
                                                                    if (!logInfo) return null;
                                                                    const logStatusInfo = getMqttCommandStatusInfo(
                                                                        logInfo.status ?? "RESPONDED"
                                                                    );
                                                                    const logStatusColor = mqttCommandStatusPalette[logStatusInfo.severity].main;

                                                                    return (
                                                                        <Paper
                                                                            key={idx}
                                                                            className="tw-rounded-xl tw-border-0 tw-bg-white tw-shadow-none"
                                                                            elevation={0}
                                                                            sx={{
                                                                                p: 2,
                                                                                display: 'flex',
                                                                                justifyContent: 'space-between',
                                                                                alignItems: 'flex-start',
                                                                                gap: 2,
                                                                                minWidth: 0,
                                                                                "& .MuiTypography-root": { overflowWrap: "anywhere" },
                                                                                ...getMqttCommandStatusCardStyle(logStatusInfo.severity),
                                                                            }}
                                                                        >
                                                                            <Box>
                                                                                <Typography variant="body1" sx={{ fontWeight: 'bold', color: logStatusColor, fontFamily: 'Prometo' }}>
                                                                                    {logInfo.displayName}
                                                                                </Typography>
                                                                                {logInfo.logData && (
                                                                                    <Typography variant="caption" sx={{ color: '#003f4a', opacity: 0.7, fontFamily: 'Prometo', fontStyle: 'italic' }}>
                                                                                        Comando: {logInfo.logData}
                                                                                    </Typography>
                                                                                )}
                                                                                {logInfo.displayDescription && (
                                                                                    <Typography variant="body2" sx={{ display: 'block', color: 'gray', fontFamily: 'Prometo' }}>
                                                                                        {logInfo.displayDescriptionLabel}: {logInfo.displayDescription}
                                                                                    </Typography>
                                                                                )}
                                                                                {logInfo.commandId && (
                                                                                    <Typography variant="caption" color="textSecondary" display="block" sx={{ fontFamily: 'Prometo' }}>
                                                                                        ID do envio: {logInfo.commandId}
                                                                                    </Typography>
                                                                                )}
                                                                                <Typography variant="caption" color="textSecondary" display="block" sx={{ fontFamily: 'Prometo' }}>
                                                                                    Data: {item.eventDateTime || "-"}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Paper>
                                                                    );
                                                                })}
                                                            </Stack>
                                                        ) : (
                                                            <Typography variant="body2" sx={{ textAlign: "center", color: "gray", py: 4 }}>
                                                                Nenhum resultado de comando disponível.
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Box>
                                            </FormControl>
                                        </Box>
                                    </SwipeableDrawer>
                                </Box>}

                                {index === 2 && <Box
                                    className="tw-w-full tw-py-2.5"
                                >
                                    <SwipeableDrawer
                                        anchor="bottom"
                                        open={isQueueOpen}
                                        onClose={toggleQueueDrawer(false)}
                                        onOpen={toggleQueueDrawer(true)}
                                        swipeAreaWidth={drawerBleeding}
                                        disableSwipeToOpen={false}
                                        PaperProps={{
                                            className: "tw-overflow-hidden tw-rounded-2xl tw-border-0 tw-bg-white tw-shadow-none",
                                            sx: {
                                                width: { xs: "calc(100% - 16px)", md: "min(92vw, 980px)" },
                                                maxHeight: "min(72dvh, 620px)",
                                                left: 0,
                                                right: 0,
                                                bottom: { xs: 72, sm: 88 },
                                                marginLeft: "auto",
                                                marginRight: "auto",
                                                borderRadius: 4,
                                                padding: 0,
                                                overflow: "hidden",
                                                backgroundColor: "#fff",
                                                boxShadow: "none",
                                            },
                                        }}
                                    >
                                        <Box
                                            className="tw-relative tw-overflow-hidden tw-bg-white tw-font-prometo"
                                            sx={{
                                                marginTop: 0,
                                                position: 'relative',
                                                visibility: isQueueOpen ? 'visible' : 'hidden'
                                            }}
                                        >
                                            <Puller />
                                            <FormControl
                                                className="tw-w-full"
                                                style={{ display: "flex", width: "100%", marginBottom: 5 }}
                                            >
                                                <Box
                                                    className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-3 tw-bg-gtr-sidebar tw-px-4 tw-pb-3 tw-pt-5 tw-text-white"
                                                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", backgroundColor: "#09414A" }}
                                                >
                                                    <InputLabel
                                                        shrink
                                                        style={{ color: "#fff", fontFamily: "Prometo", fontSize: 17, fontWeight: 700, position: 'relative', transform: 'none', marginBottom: 0 }}
                                                    >
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                            <ListAltOutlined fontSize="small" />
                                                            Fila de comandos
                                                        </Box>
                                                    </InputLabel>
                                                    <Box className="tw-flex tw-items-center tw-gap-1">
                                                        <Tooltip title="Atualizar fila" arrow>
                                                            <span>
                                                                <IconButton
                                                                    aria-label="Atualizar fila de comandos"
                                                                    disabled={loadingQueue}
                                                                    onClick={() => getCommandQueue()}
                                                                    size="small"
                                                                    sx={{ color: "#fff", "&:hover": { backgroundColor: "rgba(255,255,255,0.12)" } }}
                                                                >
                                                                    <Refresh />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                        <Tooltip title="Fechar" arrow>
                                                            <IconButton
                                                                aria-label="Fechar fila de comandos"
                                                                onClick={toggleQueueDrawer(false)}
                                                                size="small"
                                                                sx={{ color: "#fff", "&:hover": { backgroundColor: "rgba(255,255,255,0.12)" } }}
                                                            >
                                                                <CloseOutlined />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Box>
                                                </Box>
                                                {loadingQueue && (
                                                    <LinearProgress
                                                        color="success"
                                                        variant="indeterminate"
                                                    />
                                                )}
                                                <Box className="tw-bg-slate-50 tw-p-3 sm:tw-p-4" sx={{ position: 'relative' }}>
                                                    <Box sx={{
                                                        width: "100%",
                                                        maxHeight: "300px",
                                                        background: "transparent",
                                                        padding: 0,
                                                        scrollBehavior: "auto",
                                                        overflowY: "auto",
                                                        borderRadius: 0,
                                                        border: 'none',
                                                        /* Firefox */
                                                        scrollbarWidth: "thin",
                                                        scrollbarColor: "#c1c1c1 transparent",

                                                        /* Chrome, Edge, Safari */
                                                        "&::-webkit-scrollbar": {
                                                            width: "6px",
                                                        },
                                                        "&::-webkit-scrollbar-track": {
                                                            background: "transparent",
                                                        },
                                                        "&::-webkit-scrollbar-thumb": {
                                                            backgroundColor: "#c1c1c1",
                                                            borderRadius: "8px",
                                                        },
                                                        "&::-webkit-scrollbar-thumb:hover": {
                                                            backgroundColor: "#a0a0a0",
                                                        },
                                                    }}>
                                                        {loadingQueue && commandQueue.length === 0 ? (
                                                            <Stack spacing={1.25}>
                                                                {[1, 2, 3].map((i) => (
                                                                    <Skeleton key={i} variant="rectangular" height={110} sx={{ borderRadius: 1 }} />
                                                                ))}
                                                            </Stack>
                                                        ) : commandQueue.length > 0 ? (
                                                            <Stack spacing={2} sx={{ mb: 2 }}>
                                                                {commandQueue.map((item, idx) => {
                                                                    const itemStatusInfo = getMqttCommandStatusInfo(item.status);
                                                                    const itemStatusColor = mqttCommandStatusPalette[itemStatusInfo.severity].main;
                                                                    const isMqtt = item.transport?.toUpperCase() === "MQTT";
                                                                    const canCancel = item.id != null && (!isMqtt || item.status === "PENDING_PUBLISH");

                                                                    return (
                                                                        <Paper
                                                                            key={item.commandId ?? item.id ?? `${item.deviceId}-${item.createdAt}-${idx}`}
                                                                            className="tw-rounded-xl tw-border-0 tw-bg-white tw-shadow-none"
                                                                            elevation={0}
                                                                            sx={{
                                                                                p: 2,
                                                                                display: 'flex',
                                                                                justifyContent: 'space-between',
                                                                                alignItems: 'flex-start',
                                                                                gap: 2,
                                                                                minWidth: 0,
                                                                                "& .MuiTypography-root": { fontFamily: "Prometo", overflowWrap: "anywhere" },
                                                                                ...getMqttCommandStatusCardStyle(itemStatusInfo.severity),
                                                                            }}
                                                                        >
                                                                            <Box sx={{ minWidth: 0, flex: 1 }}>
                                                                                <Typography variant="body1" sx={{ fontWeight: 'bold', color: itemStatusColor, fontFamily: 'Prometo' }}>
                                                                                    {item.description || item.type || "Comando na Fila"}
                                                                                </Typography>
                                                                                <Typography variant="caption" color="textSecondary" display="block">
                                                                                    ID da fila: {item.id} | Tipo: {item.type ?? "-"} | Dispositivo: {item.deviceImei ?? "-"}
                                                                                </Typography>
                                                                                {item.transport && (
                                                                                    <Typography variant="caption" color="textSecondary" display="block">
                                                                                        Transporte: {item.transport}
                                                                                    </Typography>
                                                                                )}
                                                                                {item.status && (
                                                                                    <Typography variant="caption" color="textSecondary" display="block">
                                                                                        Status: {itemStatusInfo.label}
                                                                                    </Typography>
                                                                                )}
                                                                                {item.commandId && (
                                                                                    <Typography variant="caption" color="textSecondary" display="block">
                                                                                        ID do envio: {item.commandId}
                                                                                    </Typography>
                                                                                )}
                                                                                {item.attributes && !isMqtt && (
                                                                                    <Typography variant="caption" color="textSecondary" display="block">
                                                                                        Atributos: {item.attributes}
                                                                                    </Typography>
                                                                                )}
                                                                                <Typography variant="caption" color="textSecondary" display="block">
                                                                                    Criado em: {item.createdAt ?? "-"}
                                                                                </Typography>
                                                                                {item.expiresAt && (
                                                                                    <Typography variant="caption" color="textSecondary" display="block">
                                                                                        Expira em: {item.expiresAt}
                                                                                    </Typography>
                                                                                )}
                                                                                {item.response && (
                                                                                    <Typography variant="caption" color="textSecondary" display="block">
                                                                                        Resposta: {item.response}
                                                                                    </Typography>
                                                                                )}
                                                                                {item.error && (
                                                                                    <Typography variant="caption" color="error" display="block">
                                                                                        Erro: {item.error}
                                                                                    </Typography>
                                                                                )}
                                                                            </Box>
                                                                            <Tooltip title={canCancel ? "Cancelar comando" : "O comando MQTT não pode mais ser cancelado"} arrow>
                                                                                <span>
                                                                                    <IconButton
                                                                                        color="error"
                                                                                        aria-label="Cancelar comando da fila"
                                                                                        disabled={!canCancel}
                                                                                        onClick={() => item.id != null && verifyBeforeCancelQueueCommand(item.id)}
                                                                                        sx={{ flexShrink: 0 }}
                                                                                    >
                                                                                        <DeleteOutlineOutlined />
                                                                                    </IconButton>
                                                                                </span>
                                                                            </Tooltip>
                                                                        </Paper>
                                                                    );
                                                                })}
                                                            </Stack>
                                                        ) : (
                                                            <Typography variant="body2" sx={{ textAlign: "center", color: "gray", py: 4 }}>
                                                                Nenhum comando na fila para este dispositivo.
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Box>
                                            </FormControl>
                                        </Box>
                                    </SwipeableDrawer>
                                </Box>}
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
                <Toast
                    ref={toastModalRef}
                    position="center"
                    onShow={() => {
                        setIsToastVisible(true);
                    }}
                    onHide={() => {
                        setIsToastVisible(false);
                    }}
                />
            </Box>
        </>
    );
};

const commandActionButtonStyle = {
    minWidth: 112,
    minHeight: 42,
    px: 2,
    borderRadius: 2,
    color: "#fff",
    fontFamily: "Prometo",
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "none",
    "&.Mui-disabled": {
        color: "rgba(255,255,255,0.62)",
        backgroundColor: "#cbd5e1",
    },
};

const style = {
    bgcolor: "#ffff",
    width: "100%",
    maxWidth: "none",
    margin: "8px 0 0",
    display: "grid",
    gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "repeat(2, minmax(0, 1fr))" },
    gap: 1.5,
    border: "none",
    boxShadow: "none",
    borderRadius: 3,
    color: "black",
    justifyContent: "stretch",
    alignItems: "start",
    lineBreak: "anywhere",
    padding: { xs: 1, sm: 1.5 },
    fontFamily: "Prometo",
    "& > .col-md-12, & > .col-md-6": {
        width: "100%",
        minWidth: 0,
        margin: "0 !important",
        padding: "0 !important",
    },
    "& .MuiAutocomplete-root, & .MuiFormControl-root": { width: "100%" },
    "& .MuiOutlinedInput-root": {
        borderRadius: 2,
        backgroundColor: "#fff",
        transition: "box-shadow 180ms ease, background-color 180ms ease, border-color 180ms ease",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(0,63,74,0.24)", borderWidth: "1px" },
    "& .MuiOutlinedInput-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline": { borderColor: "#006C77", borderWidth: "1px" },
    "& .MuiInputLabel-root.Mui-focused": { color: "#00B700" },
    "& .MuiOutlinedInput-root.Mui-focused": { boxShadow: "0 0 0 3px rgba(0,183,0,0.12)" },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#00B700", borderWidth: "2px" },
};

const commandFieldsStyle = {
    width: "100%",
    minWidth: 0,
    display: "grid",
    gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(auto-fit, minmax(240px, 1fr))" },
    gap: 1.5,
    "& > [class*='col-md-']": {
        width: "100%",
        maxWidth: "none",
        minWidth: 0,
        margin: "0 !important",
        padding: "0 !important",
    },
};

const commandOptionsStyle = {
    width: "100%",
    minWidth: 0,
    display: "grid",
    gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(auto-fit, minmax(210px, 1fr))" },
    gap: 1,
    paddingTop: 2,
    borderTop: "1px solid #e2e8f0",
    "& > .col-md-3": {
        width: "100%",
        maxWidth: "none",
        minWidth: 0,
        minHeight: 56,
        display: "flex",
        alignItems: "center",
        margin: "0 !important",
        padding: "8px 12px !important",
        border: "1px solid transparent",
        borderRadius: 2,
        backgroundColor: "#fff",
        transition: "background-color 180ms ease, border-color 180ms ease",
    },
    "& > .col-md-3:hover": {
        backgroundColor: "rgba(0,108,119,0.035)",
        borderColor: "rgba(0,108,119,0.24)",
    },
    "& > .col-md-3:has(.Mui-checked)": {
        backgroundColor: "rgba(0,183,0,0.06)",
        borderColor: "rgba(0,183,0,0.38)",
    },
    "& .MuiStack-root": { width: "100%" },
    "& .MuiTypography-root": {
        color: "#334155",
        fontFamily: "Prometo",
        fontSize: 14,
        fontWeight: 600,
        lineHeight: 1.25,
    },
};

export default DeviceCommandComponent;
